<template>
  <div class="about">
      <h1>Sobre!</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>